import {
	ConclusionContent,
	ConclusionText,
	ConclusionTitle,
	ConclusionWrapper,
} from './CaseStudyConclusion.styles';

const CaseStudyConclusion = ({ title, text }: CaseStudyConclusionProps) => {
	return (
		<ConclusionWrapper>
			<ConclusionContent>
				<ConclusionTitle>{title}</ConclusionTitle>
				<ConclusionText>{text}</ConclusionText>
			</ConclusionContent>
		</ConclusionWrapper>
	);
};

export type CaseStudyConclusionProps = {
	title: string;
	text: string;
};

export default CaseStudyConclusion;
